import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, error = false, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'bg-surface flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm transition-colors',
        'placeholder:text-fg-subtle',
        'focus-visible:outline-primary-500 focus-visible:outline-2 focus-visible:outline-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        error ? 'border-error' : 'border-border-strong hover:border-border',
        className,
      )}
      {...rest}
    />
  );
});
